import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
const AI_SDR_QA_PORTAL_ID = 913441057;
export const getIsUngatedForAiSdr = () => {
  return enviro.isQa() && PortalIdParser.get() === AI_SDR_QA_PORTAL_ID;
};